import { createAsyncThunk } from "@reduxjs/toolkit";
import doFetch from "../../infrastructure/doFetch";
import { SPINNER_NAMES } from "../../components/organisms/Spinner";

const { GITHUB_SIGNIN } = SPINNER_NAMES;

export const createGithubUser = createAsyncThunk(
  "github-authentication",
  async (data, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `github-authentication`,
      method: "POST",
      config: {
        body: JSON.stringify(data),
      },
      useCache,
      showSpinner,
      spinner: GITHUB_SIGNIN,
      errorMessage: "Unable to sign-in. Please try again later....",
      successMessage: "Successfully signed-in.",
      ...args,
    })
);
